import { styled } from '@rabex-kit/rabex-ui';
import Close from '../../static/images/svg/close2.svg';
import EyeOpened from '../../static/images/svg/Eye.svg';
import EyeClosed from '../../static/images/svg/EyeClosed.svg';

// A button stripped of the browser's look: wraps an icon (or text) that has to be focusable and
// usable with Enter/Space. So the auth inputs' clear and show-password controls can be
// reached with Tab, used with Enter/Space and announced by screen readers.
export const ResetButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  background: 'none',
  border: 0,
  borderRadius: 4,
  cursor: 'pointer',
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.primary[500]}`,
    outlineOffset: 2
  }
}));

type ClearButtonProps = {
  onClick: () => void;
  // Which side of the icon the gap goes on, depending on its neighbours inside the input.
  spacing?: 'ml' | 'mr';
};

export const ClearButton = ({ onClick, spacing = 'ml' }: ClearButtonProps) => (
  <ResetButton
    type="button"
    aria-label="پاک کردن"
    onClick={onClick}
    style={{ [spacing === 'ml' ? 'marginLeft' : 'marginRight']: 8 }}>
    <img src={Close} alt="" />
  </ResetButton>
);

type PasswordToggleProps = {
  shown: boolean;
  onToggle: () => void;
};

export const PasswordToggle = ({ shown, onToggle }: PasswordToggleProps) => (
  <ResetButton
    type="button"
    aria-label={shown ? 'پنهان کردن رمز عبور' : 'نمایش رمز عبور'}
    aria-pressed={shown}
    onClick={onToggle}
    style={{ marginLeft: 8 }}>
    <img src={shown ? EyeOpened : EyeClosed} alt="" />
  </ResetButton>
);
